import * as z from "zod/v4";

export const updateCollectionReviewSettings = {
  name: "updateCollectionReviewSettings" as const,
  input: z.object({
    settings: z.object({
      smartSwitch: z.boolean(),
      minimumReviews: z.number().int().min(1),
      enabledCollections: z.array(z.string()),
    }),
  }),

  output: z.object({ success: z.boolean() }),
};
